import type { IFormTariff } from '../models';

type TActiveTariffActualization = Pick<IFormTariff, 'filteredTariffs' | 'activeTariff'> & {
    change: (name: string, value?: unknown) => void;
};

/** Актуализация данных активного тарифа при его отсутствии (назначение активного по-дефолту), или при изменении в расчетах */
export const activeTariffActualization = ({
    activeTariff,
    change,
    filteredTariffs,
}: TActiveTariffActualization) => {
    const activeTariffIsActual = filteredTariffs.find(i => i.bcode === activeTariff.bcode);

    /** Подменяем значение активного тарифа на идентичный, для смены стоимости */

    if (activeTariffIsActual) {
        change('activeTariff', activeTariffIsActual);
        change('isCorrectParameters', true);
    }

    if (filteredTariffs.length === 0) {
        change('isCorrectParameters', false);
    }

    if ((!activeTariff || !activeTariffIsActual) && filteredTariffs.length > 0) {
        change('activeTariff', filteredTariffs[0]);
    }
};
